import { render, staticRenderFns } from "./modalScoreGoal.vue?vue&type=template&id=72346ab3&"
import script from "./modalScoreGoal.vue?vue&type=script&lang=js&"
export * from "./modalScoreGoal.vue?vue&type=script&lang=js&"
import style0 from "./modalScoreGoal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports